import './style/QuizPageWrapper.css';
import { useState, useEffect } from 'react';
import PensumQuiz from './PensumQuiz';
import axios from 'axios';

interface Belt {
    id: string;
    name?: string;
    color: string;
  }
  

const QuizPageWrapper = () => {

  const initial = {
    id: "",
    name: "",
    color: "",
  } as Belt;

  const [beltColors, setBeltColors] = useState<Belt[]>([]); // State to store available belt colors
  const [selectedBelt, setSelectedBelt] = useState<Belt>(initial); // State to store the selected belt color
  const [isDropdownVisible, setIsDropdownVisible] = useState(true); // Track visibility of the dropdown

  // Fetch belt colors from the API
  useEffect(() => {
    const fetchBeltColors = async () => {
      try {
        const username = process.env.REACT_APP_API_USERNAME;
        const password = process.env.REACT_APP_API_PASSWORD;
        const token = btoa(`${username}:${password}`); // Base64 encode username and password
        const response = await axios.get<Belt[]>(
          `${process.env.REACT_APP_API_URL}/Belt`, // Replace with actual endpoint
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

        setBeltColors(response.data); // Assuming the API returns an array of belt colors
      } catch (error) {
        console.error('Error fetching belt colors:', error);
      }
    };

    fetchBeltColors();
  }, []);
  // Handle dropdown change
  const handleBeltChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = event.target.value;
    const selectedBelt = beltColors.find(belt => belt.id === selectedId);
    console.log('selectedBelt.color : ',selectedId);
    if (selectedBelt) {

      setSelectedBelt(selectedBelt); // Set the selected belt
      if (selectedBelt.id !== undefined && selectedBelt.color !== "hvid") {
          setIsDropdownVisible(false); // Hide dropdown after selection
      }
    } else {
      setSelectedBelt(initial); // Reset if no belt selected
    }
  };

  return (
    <>
      {isDropdownVisible && (
        <div className="dropdown-container">
        <><label className="dropdown-label">Vælg bæltefarve</label><select className="belt-dropdown" value={selectedBelt.id} onChange={handleBeltChange}>
                    <option value="">-- Vælg bæltefarve --</option>
                    {beltColors.map((belt) => (
                        <option key={belt.id} value={belt.id}>
                            {belt.color}
                        </option>
                    ))}
                </select></>
        </div>
      )}
    {selectedBelt.id && <PensumQuiz selectedBelt={selectedBelt.color} />}
    </>
  );
};

export default QuizPageWrapper;
